module.exports = __webpack_public_path__ + "static/media/LT1.61c9c908.jpg";